import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NavigationEnd, Router, Event } from '@angular/router';
import { AppSandbox } from '../../app.sandbox';
import { HttpClient } from '@angular/common/http';
import { ASSET_BASE_URL } from '../../app.data.service';
import { SearchComponent } from '../search/search.component';
import { Homepage, HomepageList, HomepageService } from '../../../generated';
import { filter } from 'rxjs/operators';

declare var $: any;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  MEDIUM_BASE_MEDIA_URL = ASSET_BASE_URL + '/medium';
  BASE_MEDIA_URL = ASSET_BASE_URL;

  @ViewChild(SearchComponent, {static: true}) searchComponent: SearchComponent;
  @ViewChild('searchInput', {static: true}) searchInputRef: ElementRef;

  page: string = null;
  itemsInCartCount = 0;
  mobileDropdownLanguagesOpen = false;
  mobileDropdownLinksOpen = false;
  searchText: string;
  currentWeather = null;
  visitMenuHovered = false;
  moreMenuHovered = false;
  homePageData: Homepage;

  constructor(private router: Router,
              private sandbox: AppSandbox,
              private httpClient: HttpClient,
              private homepageService: HomepageService) {

    router.events.subscribe((event: Event): void => {
      if (event instanceof NavigationEnd) {
        // Navigation Ended Successfully.
        // console.log(event.url);
        this.page = event.url;
        this.mobileDropdownLanguagesOpen = false;
        this.mobileDropdownLinksOpen = false;
      }
    });
  }

  async ngOnInit() {
    this.getHomePageData();
    this.sandbox.cart$.subscribe((cart) => {
      if (!!cart) {
        let count = 0;
        cart.forEach(o => count += o.quantity);
        this.itemsInCartCount = count;
      //console.log('num items in cart now', this.itemsInCartCount);
      } else {
        this.itemsInCartCount = 0;
      }
    });


    // format: https://darksky.net/dev/docs#forecast-request
    // const currentWeather: any = await this.httpClient.get('/.netlify/functions/darksky?lat=34.066&lon=-118.347').toPromise();
    // if (!!currentWeather) {
    //   this.currentWeather = currentWeather.currently;
    // }
    // console.log('currentWeather', this.currentWeather);
  }

  getIcon() {
    const icon = this.currentWeather.icon;

    let weatherIcon = 'na';
    switch (icon) {
      case 'clear-day':
        weatherIcon = 'wi-day-sunny';
        break;
      case 'clear-night':
        weatherIcon = 'wi-night-clear';
        break;
      case 'rain':
        weatherIcon = 'wi-rain';
        break;
      case 'snow':
        weatherIcon = 'wi-snow';
        break;
      case 'sleet':
        weatherIcon = 'wi-sleet';
        break;
      case 'wind':
        weatherIcon = 'wi-strong-wind';
        break;
      case 'fog':
        weatherIcon = 'wi-fog';
        break;
      case 'cloudy':
        weatherIcon = 'wi-cloud';
        break;
      case 'partly-cloudy-day':
        weatherIcon = 'wi-day-cloudy';
        break;
      case 'partly-cloudy-night':
        weatherIcon = 'wi-night-alt-partly-cloudy';
    }

    return weatherIcon;
  }

  getTemp() {
    return Math.floor(this.currentWeather.temperature);
  }

  async getHomePageData() {
    const homePageList: HomepageList = await this.homepageService.getOrgsOrgnameHomepage('global', true).toPromise();
    if (!!homePageList && !!homePageList[0]) {
      this.homePageData = homePageList[0];
    }
    // console.log('init(): homepage data', this.homePageData);
  }

  goto(href) {
    // console.log('goto', href);
    window.open(href, '_blank');
  }

  toggleDropdownLinks() {
    this.mobileDropdownLinksOpen = !this.mobileDropdownLinksOpen;
    if (this.mobileDropdownLanguagesOpen === true) {
      this.mobileDropdownLanguagesOpen = false;
    }

    // add class to body, so we can prevent scrolling while nav menu up
    if (this.mobileDropdownLinksOpen) {
      $('body').addClass('modal-open');
    } else {
      $('body').removeClass('modal-open');
    }
  }

  toggleDropdownLanguages() {
    this.mobileDropdownLanguagesOpen = !this.mobileDropdownLanguagesOpen;
    if (this.mobileDropdownLinksOpen === true) {
      this.mobileDropdownLinksOpen = false;
      // $('body').removeClass('modal-open');
    }

    if (this.mobileDropdownLanguagesOpen) {
      $('body').addClass('modal-open');
    } else {
      $('body').removeClass('modal-open');
    }
  }

  keyUp(event) {
    // console.log('search()', event);

    this.searchComponent.search(event, this.searchText);
  }

  searchOpened() {
  //console.log('search opened');
    setTimeout(() => {
    //console.log('setting focus');
      // select content, so typing replaces current search
      this.searchInputRef.nativeElement.focus();
      this.searchInputRef.nativeElement.select();
    }, 500);
  }

  searchClosed() {
  //console.log('search closed');
  }

  scroll(event) {
  //console.log('scrolling');
    event.stopPropagation();
  }

  visitMenuClicked(event) {
    event.stopPropagation();
    this.visitMenuOut();
  }

  visitMenuEnter() {
    this.visitMenuHovered = true;
  }

  visitMenuOut() {
    this.visitMenuHovered = false;
  }

  moreMenuEnter() {
    this.moreMenuHovered = true;
  }

  moreMenuOut() {
    this.moreMenuHovered = false;
  }

}
